/**
 * Very rudimentary dropdown menu component. Needs a lot of work to actually be reusable.
 */

import * as angular from 'angular';
import * as $ from 'jquery';

export const KebabMenuDirective: angular.IDirectiveFactory = function (
  $document,
  $rootScope: angular.IRootScopeService
) {
  let documentListenerAdded = false;
  const emitHideMenuEvent = function (event) {
    $rootScope.$emit('dropdown-menu-document-click', event);
  };

  return {
    scope: {
      targetable: '<',
      open: '<',
    },
    restrict: 'E',
    transclude: true,

    template: `<div class="action-menu dropdown-toggle" ng-click="show($event)" ng-class="{'targetable': targetable}">
      <i ng-if="!targetable" class="align-md-icon icon-menu-dots-gray"></i>
      <svg-icon ng-if="targetable" type="'kebab'"></svg-icon>
    </div>
    <ul class="dropdown-menu pull-right" ng-class="{'dropdown-open': open}" ng-transclude ng-click="hide()">
    </ul>`,

    link: function ($scope, $elem, attrs, ctrl) {
      if (!documentListenerAdded) {
        $document[0].addEventListener('click', emitHideMenuEvent);
        documentListenerAdded = true;
      }

      const off = $rootScope.$on('dropdown-menu-document-click', ($event, nativeEvent) => {
        if ($scope.open && !$elem[0].contains(nativeEvent.target)) {
          $scope.$applyAsync(() => {
            $scope.hide();
          });
        }
      });

      ($scope.show = function ($event) {
        this.open = !this.open;
      }),
        ($scope.hide = function () {
          this.open = false;
        });

      $scope.$on('$destroy', () => {
        off();
      });
    },
  };
};

KebabMenuDirective.$inject = ['$document', '$rootScope'];
